// Route: /collections/$setId — LEGACY redirect → /library/folders/$folderId.
//
// Деталь папки переехала под `/library` (2026-08-14): до этого список сущности
// жил под одним префиксом, а её карточка — под другим, то есть один и тот же
// объект был разложен по разным разделам.
//
// ЭТОТ РЕДИРЕКТ УБИРАТЬ НЕЛЬЗЯ, и он долгоживущий: строки `/collections/<id>`
// лежат не только в закладках, а в БД — инструменты репетитора
// (`manage-collection.ts`, `undo-last-action.ts`, `validate-actions.ts`)
// клали такой deep-link в карточки сообщений, и старая переписка остаётся у
// пользователя навсегда. Сервер новые ссылки уже пишет каноном, поэтому
// новых записей не прибавляется — но и существующие никуда не денутся.
//
// Search не переносим: у целевого роута его нет вовсе (см. гейт
// `routes/__tests__/redirect-search.test.ts` — переклад обязан быть явным).

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/collections/$setId")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/library/folders/$folderId",
			params: { folderId: params.setId },
			replace: true,
		});
	},
});
